import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, Modal, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, CardContent, Card } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from "@mui/material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, getGridStringOperators } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import searchIcon from "../../icons/searchIcon.svg"
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const TodayPunchModal = ({ onClose, is_download }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataGrid, setDataGrid] = useState([]);
    const [rowCount, setRowCount] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({
        page: currentPage - 1,
        pageSize: 20,
    });

    const [modalData, setModalData] = useState([])
    const [openViewModal, setOpenViewModal] = useState(false)
    const [todayPunches, setTodayPunches] = useState([]);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)

    useEffect(() => {
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    useEffect(() => {
        if (dataGrid.length > 0) {
            findData();
        }
    }, [paginationModel.page, paginationModel.pageSize]);

    useEffect(()=>{
        setDataGrid([]);
        setRsm("");
        setAsm("");
        setRm("");
    },[tabValue])

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    const exportroutes = async () => {
        setLoading(true);
        try {
            let data = {

                user_name: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm
            }
            let result = await window.Platform.database.exportData("attendance/downloadTodayAttendanceExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${formattedDate}_Punches.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    const exportNoTodaysPunches = async () => {
        console.log("ertyuytrertyuiuyreswrtyuiuytre")
        setLoading(true);
        try {
            let data = {

                user_name: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm
            }
            let result = await window.Platform.database.exportData("attendance/downloadNotPunchedExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${formattedDate}_Not_Punched.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    const exportDownloadTodayAllPunches = async () => {
        console.log("ertyuytrertyuiuyreswrtyuiuytre")
        setLoading(true);
        try {
            let data = {

                user_name: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm
            }
            let result = await window.Platform.database.exportData("attendance/downloadTodayAllPunches",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${formattedDate}_All_Staff_Punched.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    const handleOpenViewModal = (id) => {
        console.log(id, "isdsdsdsd")
        setModalData(id)
        setOpenViewModal(true);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setModalData([]);
    }

    async function getUsers(role, id) {
        setLoading(true);
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
            setLoading(false);
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
            setLoading(false);
        }
    }

    const findData = async () => {
        setLoading(true);
        if (tabValue == 0) {
            getTodayAttendancePnches();
        }
        else if (tabValue == 2) {
            getTodayAllPunchStatus()
        }
        else {
            getNoTodayAttendancePnches();
        }
    }

    const getTodayAttendancePnches = async () => {
        setLoading(true);
        try {
            let data = {
                recordPerPage: paginationModel.pageSize,
                pageNumber: paginationModel.page,
                ownerId: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            };
            let results = await window.Platform.database.getTodayAttendancePnches(data);
            if (results.success) {
                setTodayPunches(results?.data);
                setDataGrid(results?.data);

                window.NotificationUtils.showSuccess(results?.message);
                setRowCount(results.totalCount);
                setLoading(false);
            }
            else {
                window.NotificationUtils.showError("Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const getNoTodayAttendancePnches = async () => {
        setLoading(true);
        try {
            let data = {
                recordPerPage: paginationModel.pageSize,
                pageNumber: paginationModel.page,
                ownerId: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            };
            let results = await window.Platform.database.getTodayNotPunchedUsers(data);
            if (results.success) {
                setTodayPunches(results?.data);
                setDataGrid(results?.data);

                window.NotificationUtils.showSuccess(results?.message);
                setRowCount(results.totalCount);
                setLoading(false);
            }
            else {
                window.NotificationUtils.showError("Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const getTodayAllPunchStatus = async () => {
        setLoading(true);
        try {
            let data = {
                recordPerPage: paginationModel.pageSize,
                pageNumber: paginationModel.page,
                ownerId: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
            };
            let results = await window.Platform.database.getTodayAllPunchStatus(data);
            if (results.success) {
                setTodayPunches(results?.data);
                setDataGrid(results?.data);

                window.NotificationUtils.showSuccess(results?.message);
                setRowCount(results.totalCount);
                setLoading(false);
            }
            else {
                window.NotificationUtils.showError("Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const openPackaging = (val) => {
        const url = window.Platform.database.funcForBaseURL() + "/file" + val;
        setImageUrl(url);
        setImageModalOpen(true);
    };

    const renderContent1 = () => {
        return (
            <>
                {/* <Stack direction={"row"} spacing={2} padding={2}> */}

                <div className="row mt-2 mb-3">
                    {userData?.role.includes('admin') &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select HO</InputLabel>
                                <Select
                                    labelId="Select HO"
                                    id="select"
                                    value={rsm}
                                    fullWidth
                                    onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setRm(""); setAsm("") }}
                                    label="Select HO"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                    {/* {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))} */}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    {userData?.role != 'asm' &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select ARM</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="select"
                                    value={asm}
                                    fullWidth
                                    onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }}
                                    label="Select ARM"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                    {/* {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))} */}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    <div className="col-md-3">
                        <FormControl fullWidth size="small">
                            <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select RM</InputLabel>
                            <Select
                                labelId="select-label"
                                id="select"
                                value={rm}
                                fullWidth
                                onChange={(e) => { setRm(e.target.value); }}
                                label="Select RM"
                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                            >
                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                {/* {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))} */}
                            </Select>
                        </FormControl>
                    </div>
                    {is_download && <div className="col-md-3">
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            fullWidth
                            sx={{ fontSize: '14px', borderRadius: '10px' }}
                            onClick={exportroutes}
                        >
                            Download
                        </Button>
                    </div>}
                </div>
                <div className="row mt-2">
                    <div className="col-md-3">
                        <FormControl fullWidth size="small">
                            <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => {
                                // setDataGrid([]); // Clear grid to allow pagination effect
                                findData();
                            }}>
                                Find
                            </Button>
                        </FormControl>
                    </div>
                    <div className="col-md-2">
                        <FormControl fullWidth size="small">
                            <Stack direction={"row"} >
                                <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500", marginTop: "11px" }}>Select Page Size:&nbsp;</Typography>
                                <Select
                                    value={paginationModel.pageSize}
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    {[10, 20, 30, 50, 100].map((role) => (
                                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                                    ))}
                                </Select>
                            </Stack>
                        </FormControl>
                    </div>
                </div>
                {/* </Stack> */}
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>

                    {(!dataGrid || dataGrid.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !dataGrid.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={dataGrid || []}
                                columns={getColumns()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                                getRowId={(row, index) => `${row.id}-${row.userName}` || index}
                            />
                        )}
                </Stack>
            </>
        )
    }
    const renderContent = () => {
        return (
            <>
                {/* <Stack direction={"row"} spacing={2} padding={2}> */}

                <div className="row mt-2 mb-3">
                    {userData?.role.includes('admin') &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select HO</InputLabel>
                                <Select
                                    labelId="Select HO"
                                    id="select"
                                    value={rsm}
                                    fullWidth
                                    onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setRm(""); setAsm("") }}
                                    label="Select HO"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </div>
                    }

                    {userData?.role != 'asm' &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select ARM</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="select"
                                    value={asm}
                                    fullWidth
                                    onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }}
                                    label="Select ARM"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    <div className="col-md-3">
                        <FormControl fullWidth size="small">
                            <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select RM</InputLabel>
                            <Select
                                labelId="select-label"
                                id="select"
                                value={rm}
                                fullWidth
                                onChange={(e) => { setRm(e.target.value); }}
                                label="Select RM"
                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                            >
                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </div>
                   {is_download && <div className="col-md-3">
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            fullWidth
                            sx={{ fontSize: '14px', borderRadius: '10px' }}
                            onClick={exportNoTodaysPunches}
                        >
                            Download
                        </Button>
                    </div>}
                </div>
                <div className="row mt-2">
                    <div className="col-md-3">
                        <FormControl fullWidth size="small">
                            <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => {
                                // setDataGrid([]); // Clear grid to allow pagination effect
                                findData();
                            }}>
                                Find
                            </Button>
                        </FormControl>
                    </div>
                    <div className="col-md-2">
                        <FormControl fullWidth size="small">
                            <Stack direction={"row"} >
                                <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500", marginTop: "11px" }}>Select Page Size:&nbsp;</Typography>
                                <Select
                                    value={paginationModel.pageSize}
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    {[10, 20, 30, 50, 100].map((role) => (
                                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                                    ))}
                                </Select>
                            </Stack>
                        </FormControl>
                    </div>
                </div>

                {/* </Stack> */}
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>

                    {(!dataGrid || dataGrid.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !dataGrid.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={dataGrid || []}
                                columns={getColumns1()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                                getRowId={(row, index) => `${row.id}-${row.userName}` || index}
                            />
                        )}
                </Stack>
            </>
        )
    }

    const renderContent2 = () => {
        return (
            <>
                <div className="row mt-2 mb-3">
                    {userData?.role.includes('admin') &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select HO</InputLabel>
                                <Select
                                    labelId="Select HO"
                                    id="select"
                                    value={rsm}
                                    fullWidth
                                    onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setRm(""); setAsm("") }}
                                    label="Select HO"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </div>
                    }

                    {userData?.role != 'asm' &&
                        <div className="col-md-3">
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select ARM</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="select"
                                    value={asm}
                                    fullWidth
                                    onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }}
                                    label="Select ARM"
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                    {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    <div className="col-md-2">
                        <FormControl fullWidth size="small">
                            <InputLabel id="select-label" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select RM</InputLabel>
                            <Select
                                labelId="select-label"
                                id="select"
                                value={rm}
                                fullWidth
                                onChange={(e) => { setRm(e.target.value); }}
                                label="Select RM"
                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                            >
                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </div>
                   {is_download && <div className="col-md-2">
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            fullWidth
                            sx={{ fontSize: '14px', borderRadius: '10px' }}
                            onClick={exportDownloadTodayAllPunches}
                        >
                            Download
                        </Button>
                    </div>}

                </div>
                <div className="row mt-2">
                    <div className="col-md-3">
                        <FormControl fullWidth size="small">
                            <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => {
                                // setDataGrid([]); // Clear grid to allow pagination effect
                                findData();
                            }}>
                                Find
                            </Button>
                        </FormControl>
                    </div>
                    <div className="col-md-2">
                        <FormControl fullWidth size="small">
                            <Stack direction={"row"} >
                                <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500", marginTop: "11px" }}>Select Page Size:&nbsp;</Typography>
                                <Select
                                    value={paginationModel.pageSize}
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                                    sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                >
                                    {[10, 20, 30, 40, 50, 60].map((role) => (
                                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                                    ))}
                                </Select>
                            </Stack>
                        </FormControl>
                    </div>
                </div>
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>
                    {(!dataGrid || dataGrid.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !dataGrid.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={dataGrid || []}
                                columns={getColumns2()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                                getRowId={(row, index) => `${row.id}-${row.userName}` || index}
                            />
                        )}
                </Stack>
            </>
        )
    }

    const getColumns = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        let result = [
            {
                field: "name",
                headerName: "Name",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.user_name?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ") || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "work_type",
                headerName: "Work Type",
                sortable: false,
                width: 100,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.work_type
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "in_time",
                headerName: "Start Time",
                sortable: false,
                width: 90,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.in_time?.slice(11)
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "visitCount1",
                headerName: "Visit Count",
                sortable: false,
                width: 90,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.todayVisitCount == 0 ? "0" : params.row?.todayVisitCount || "0";
                    return (
                        <Tooltip title={name || "0"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "0"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "in_Km",
                headerName: "Start KM",
                sortable: false,
                width: 80,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.in_km
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "in_manual_reading",
                headerName: "In Manual Reading",
                sortable: false,
                width: 130,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.in_manual_reading == 0 ? "No" : "Yes"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "out_time",
                headerName: "End Time",
                sortable: false,
                width: 100,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.out_time?.slice(11)
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "out_Km",
                headerName: "End KM",
                sortable: false,
                width: 90,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.out_km
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "out_manual_reading",
                headerName: "Out Manual Reading",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                // editable: false,
                renderCell: (params) => {
                    let name = params.row?.out_manual_reading == 0 ? "No" : "Yes"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "distance",
                headerName: "Distance",
                sortable: false,
                width: 90,
                filterOperators: stringOperators,
                // editable: false,
                renderCell: (params) => {
                    let name = params.row?.distance
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "in_lat_long",
                headerName: "Start Lat Long",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.in_latitude + ", " + params.row?.in_longitude
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "out_lat_long",
                headerName: "End Lat Long",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.out_latitude + ", " + params.row?.out_longitude
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "in_out_images",
                headerName: "In/Out Images",
                sortable: false,
                width: 120,
                filterable: false,
                renderCell: (params) => (
                    <Box display="flex" gap={1}>
                        <Tooltip title="View In Image">
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={!params.row?.in_image}
                                // onClick={e => {
                                //     e.stopPropagation();
                                //     setImageUrl(params.row?.in_image);
                                //     setImageModalOpen(true);
                                // }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openPackaging(params.row?.in_image);
                                }}
                            >
                                <RemoveRedEyeIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Out Image">
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={!params.row?.out_image}
                                // onClick={e => {
                                //     e.stopPropagation();
                                //     setImageUrl(params.row?.out_image);
                                //     setImageModalOpen(true);
                                // }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openPackaging(params?.row?.out_image);
                                }}
                            >
                                <RemoveRedEyeIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                ),
            }
        ];
        return result
    };

    const getColumns1 = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        let result = [
            {
                field: "name",
                headerName: "Name",
                sortable: false,
                width: 220,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.rm_name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "userName",
                headerName: "User Name",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.userName
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "reportinM",
                headerName: "Reporting Manger",
                sortable: false,
                width: 170,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.reportingManagerName
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "mobNo",
                headerName: "Mobile Number",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.mobno
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "email1",
                headerName: "Email",
                sortable: false,
                width: 200,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.email
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "area",
                headerName: "Area",
                sortable: false,
                width: 100,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.area
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "rem",
                headerName: "Remark",
                sortable: false,
                width: 100,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.remark
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
        ];
        return result
    };

    const getColumns2 = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        let result = [
            {
                field: "name",
                headerName: "Name",
                sortable: false,
                width: 220,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.rm_name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "userName",
                headerName: "User Name",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.userName
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>{console.log(params.row, "params.row")}
                        </Tooltip>
                    )
                },
            },
            {
                field: "reportinM",
                headerName: "Reporting Manger",
                sortable: false,
                width: 170,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.reportingManagerName
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "mobNo",
                headerName: "Mobile Number",
                sortable: false,
                width: 150,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.mobno
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "email1",
                headerName: "Email",
                sortable: false,
                width: 200,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.email
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "area",
                headerName: "Area",
                sortable: false,
                width: 100,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let name = params.row?.area
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "View",
                headerName: "View",
                minWidth: 140,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            <Tooltip>
                                <span>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleOpenViewModal(params.row)}
                                        sx={{ minWidth: "80px" }}
                                    >
                                        {"View"}
                                    </Button>
                                </span>
                            </Tooltip>
                            <Modal open={openViewModal} onClose={handleCloseViewModal}>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "80%",
                                        maxWidth: 900,
                                        bgcolor: "white",
                                        boxShadow: 24,
                                        p: 4,
                                        borderRadius: 2,
                                        maxHeight: "90%",
                                        overflowY: "auto",
                                    }}
                                >
                                    <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                                        Allowances
                                    </Typography>
                                    <div className="row mb-3 mt-2">
                                        <div className="col-md-6">
                                            <b>Name :</b> {modalData?.rm_name || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>User Name :</b> {modalData?.userName || "N/A"}
                                        </div>
                                    </div>
                                    <div className="row mb-3 mt-2">
                                        <div className="col-md-6">
                                            <b>Reporting Manager :</b> {modalData?.reportingManagerName || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>Mobile Number :</b> {modalData?.mobno || "N/A"}
                                        </div>
                                    </div>
                                    <div className="row mb-3 mt-2">
                                        <div className="col-md-6">
                                            <b>Area :</b> {modalData?.area || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>Email :</b> {modalData?.email || "N/A"}
                                        </div>
                                    </div>
                                    <div className="row mb-3 mt-2">
                                        <div className="col-md-6">
                                            <b>Remark :</b> {modalData?.remark || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>Start Time :</b> {modalData?.in_time?.slice(11) || "N/A"}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <b>Start KM :</b> {modalData?.in_km || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>In Manual Reading :</b> {modalData?.in_manual_reading === 0 ? "No" : "Yes"}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <b>End Time :</b> {modalData?.out_time?.slice(11) || "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>End KM :</b> {modalData?.out_km || "N/A"}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <b>Out Manual Reading :</b> {modalData?.out_manual_reading === 0 ? "No" : "Yes"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>Distance :</b> {modalData?.distance || "N/A"}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <b>Start Lat Long :</b>{" "}
                                            {modalData?.in_latitude && modalData?.in_longitude
                                                ? `${modalData.in_latitude}, ${modalData.in_longitude}`
                                                : "N/A"}
                                        </div>
                                        <div className="col-md-6">
                                            <b>End Lat Long :</b>{" "}
                                            {modalData?.out_latitude && modalData?.out_longitude
                                                ? `${modalData.out_latitude}, ${modalData.out_longitude}`
                                                : "N/A"}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <b>In Image :</b>
                                            {modalData?.in_image ? (
                                                <Button
                                                    size="small"
                                                    onClick={() => openPackaging(modalData.in_image)}
                                                    variant="outlined"
                                                    sx={{ ml: 1 }}
                                                >
                                                    View
                                                </Button>
                                            ) : (
                                                " N/A"
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <b>Out Image :</b>
                                            {modalData?.out_image ? (
                                                <Button
                                                    size="small"
                                                    onClick={() => openPackaging(modalData.out_image)}
                                                    variant="outlined"
                                                    sx={{ ml: 1 }}
                                                >
                                                    View
                                                </Button>
                                            ) : (
                                                " N/A"
                                            )}
                                        </div>
                                    </div>

                                    <Box mt={2} display="flex" justifyContent="flex-end">
                                        <Button onClick={handleCloseViewModal} variant="contained" color="primary">
                                            Close
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    );
                },
            },
            // {
            //     field: "rem",
            //     headerName: "Remark",
            //     sortable: false,
            //     width: 100,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.remark
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "work_type",
            //     headerName: "Work Type",
            //     sortable: false,
            //     width: 100,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.work_type
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "in_time",
            //     headerName: "Start Time",
            //     sortable: false,
            //     width: 90,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.in_time?.slice(11)
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "in_Km",
            //     headerName: "Start KM",
            //     sortable: false,
            //     width: 80,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.in_km
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "in_manual_reading",
            //     headerName: "In Manual Reading",
            //     sortable: false,
            //     width: 130,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.in_manual_reading == 0 ? "No" : "Yes"
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "out_time",
            //     headerName: "End Time",
            //     sortable: false,
            //     width: 100,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.out_time?.slice(11)
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "out_Km",
            //     headerName: "End KM",
            //     sortable: false,
            //     width: 90,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.out_km
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "out_manual_reading",
            //     headerName: "Out Manual Reading",
            //     sortable: false,
            //     width: 150,
            //     filterOperators: stringOperators,
            //     // editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.out_manual_reading == 0 ? "No" : "Yes"
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "distance",
            //     headerName: "Distance",
            //     sortable: false,
            //     width: 90,
            //     filterOperators: stringOperators,
            //     // editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.distance
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "in_lat_long",
            //     headerName: "Start Lat Long",
            //     sortable: false,
            //     width: 150,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.in_latitude + ", " + params.row?.in_longitude
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "out_lat_long",
            //     headerName: "End Lat Long",
            //     sortable: false,
            //     width: 150,
            //     filterOperators: stringOperators,
            //     editable: false,
            //     renderCell: (params) => {
            //         let name = params.row?.out_latitude + ", " + params.row?.out_longitude
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "11px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            // {
            //     field: "in_out_images",
            //     headerName: "In/Out Images",
            //     sortable: false,
            //     width: 120,
            //     filterable: false,
            //     renderCell: (params) => (
            //         <Box display="flex" gap={1}>
            //             <Tooltip title="View In Image">
            //                 <IconButton
            //                     size="small"
            //                     color="primary"
            //                     disabled={!params.row?.in_image}
            //                     // onClick={e => {
            //                     //     e.stopPropagation();
            //                     //     setImageUrl(params.row?.in_image);
            //                     //     setImageModalOpen(true);
            //                     // }}
            //                     onClick={(e) => {
            //                         e.stopPropagation();
            //                         openPackaging(params.row?.in_image);
            //                     }}
            //                 >
            //                     <RemoveRedEyeIcon fontSize="small" />
            //                 </IconButton>
            //             </Tooltip>
            //             <Tooltip title="View Out Image">
            //                 <IconButton
            //                     size="small"
            //                     color="primary"
            //                     disabled={!params.row?.out_image}
            //                     // onClick={e => {
            //                     //     e.stopPropagation();
            //                     //     setImageUrl(params.row?.out_image);
            //                     //     setImageModalOpen(true);
            //                     // }}
            //                     onClick={(e) => {
            //                         e.stopPropagation();
            //                         openPackaging(params?.row?.out_image);
            //                     }}
            //                 >
            //                     <RemoveRedEyeIcon fontSize="small" />
            //                 </IconButton>
            //             </Tooltip>
            //         </Box>
            //     ),
            // }
        ];
        return result
    };

    return (
        <>
            <Dialog disableEnforceFocus maxWidth="xl" fullWidth={true} open={true} >
                {loading && <OpaqueLoading />}
                <ModalHeaderContainer style={{ marginBottom: 0, paddingBottom: 1 }}>
                    <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: "500", color: "black" }}>
                        Today's Punches Report (
                        <span style={{ fontSize: isMobile ? 14 : 16, marginLeft: 12 }}>
                            {new Date().toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })}
                        </span> )
                        <Tooltip title="Order Id"></Tooltip>
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        <StyledTabs
                            variant="fullWidth"
                            value={tabValue}
                            onChange={handleChangeTab}
                            indicatorColor="none"
                            textColor="primary"
                        >
                            <Tab label="Today's Punches Report "  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: tabValue == 0 ? "#fff" : "#e6e3e3de " }} />
                            <Tab label="Not Punched Today"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: tabValue == 1 ? "#fff" : "#e6e3e3de " }} />
                            <Tab label="All Staff"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: tabValue == 2 ? "#fff" : "#e6e3e3de " }} />
                        </StyledTabs>
                        {tabValue == 0 && renderContent1()}
                        {tabValue == 1 && renderContent()}
                        {tabValue == 2 && renderContent2()}
                    </TabsContainer>
                </TableContainer>
            </Dialog>

            <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="md">
                <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", p: 2, position: "relative" }}>
                    <IconButton aria-label="close" onClick={() => setImageModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, minWidth: 200, }}>
                        <img src={imageUrl} alt="Attendance" style={{ maxWidth: "100%", maxHeight: "70vh", height: "auto", width: "auto", borderRadius: 8, display: "block", margin: "0 auto" }} />
                    </Box>
                </DialogContent>
            </Dialog>

        </>
    );
};
export default TodayPunchModal;